import React, { useEffect, useState } from "react";
import useStyles from "./Report.css";
import translation from "../../i18n/i18.json";
import Grid from "@material-ui/core/Grid";
import { Button, MenuItem, Select, TextField } from "@material-ui/core";
import { ReportFilter } from "../../models/Report/ReportFilter";
import SearchIcon from "@material-ui/icons/Search";
import { ReportService } from "../../services/ReportService";
import { VendorType } from "../../models/VendorType";
import { useDispatch } from "react-redux";
import AllActions from "../../actions";
import { InforDisplyaDuration, RequestStatus, RequestStatusLabel, VendorTypeData } from "../../constants/AppConstants";
import GetAppIcon from "@material-ui/icons/GetApp";
import { VendorMasterData } from "../../services/VendorMasterData";
import { Company } from "../../models/Company";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { MasterDataService } from "../../services/MasterDataService";
import { User } from "../../models/Master/User";
import { RequestStatusModel } from "../../models/RequestStatusModel";
import { ApprovalLevel } from "../../models/Master/ApprovalLevel";
import { MasterMetaDataService } from "../../services/MasterMetaDataService";
import { Code } from "@material-ui/icons";

export default function Report() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const reportTypeList = [
    { code: 1, name: "Status Report" },
    { code: 2, name: "Billing Report" },
    { code: 3, name: "Approval Status Report" },
    { code: 4, name: "Pending Request Report" },
    { code: 5, name: "Inactive Vendor Report" },
    { code: 6, name: "Onboarded Vendor Report" },
    { code: 7, name: "Auto Block Extension Vendor Report" },
    { code: 8, name: "Auto Blocked Vendor Report" }
  ];

  const [filterParams, setFilterParams] = useState<ReportFilter>({
    reportType: 0,
    fromDate: "",
    toDate: "",
    companyCodes: [],
    userIds: [],
    approvalPointIds: [],
    requestStatusIds: [],
    timeZone: new Date().getTimezoneOffset(),
    vendorTypes: [],
    inActiveFromDate: ""
  });

  const [companyList, setCompanyList] = useState(Array<Company>());
  const [approvalPointList, setApprovalPointList] = useState(Array<ApprovalLevel>());
  const [userList, setUserList] = useState(Array<User>());
  const [filteredUserList, setFilteredUserList] = useState(Array<User>());
  const [userInputValue, setUserInputValue] = React.useState('');
  const [vendorInputValue, setVendorInputValue] = useState("");
  const [selectedVendorTypes, setSelectedVendorTypes] = useState<VendorType[]>([]);

  const [requestStatus, setRequestStatus] = useState<RequestStatusModel[]>([
    { id: RequestStatus.Initial, name: RequestStatusLabel.Initial },
    { id: RequestStatus.Pending, name: RequestStatusLabel.Pending },
    { id: RequestStatus.Complete, name: RequestStatusLabel.Complete },
    { id: RequestStatus.Rejected, name: RequestStatusLabel.Rejected },
    { id: RequestStatus.Cancelled, name: RequestStatusLabel.Cancelled },
  ]);
  const [vendorTypes, setVendorTypes] = useState<VendorType[]>([
    { code: VendorTypeData.RMProductionRelated, name: VendorTypeData.RMProductionRelated },
    { code: VendorTypeData.FixedAssetsConsumables, name: VendorTypeData.FixedAssetsConsumables },
    { code: VendorTypeData.Services, name: VendorTypeData.Services },
    { code: VendorTypeData.FreightForwarder, name: VendorTypeData.FreightForwarder },
  ]);

  const [allendorTypes, setAllVendorTypes] = useState<VendorType[]>([
    { code: VendorTypeData.RMProductionRelated, name: VendorTypeData.RMProductionRelated },
    { code: VendorTypeData.AffiliatedVendorsWithinMAS, name: VendorTypeData.AffiliatedVendorsWithinMAS },
    { code: VendorTypeData.FixedAssetsConsumables, name: VendorTypeData.FixedAssetsConsumables },
    { code: VendorTypeData.Services, name: VendorTypeData.Services },
    { code: VendorTypeData.GoodsSupplier, name: VendorTypeData.GoodsSupplier },
    { code: VendorTypeData.FreightForwarder, name: VendorTypeData.FreightForwarder },
    { code: VendorTypeData.Employee, name: VendorTypeData.Employee },
    { code: VendorTypeData.OneTimeVendor, name: VendorTypeData.OneTimeVendor },
    { code: VendorTypeData.Plant, name: VendorTypeData.Plant },
    { code: VendorTypeData.Carriers, name: VendorTypeData.Carriers }
  ]);



  useEffect(() => {
    getCompanies();
    getUsers();
    getApprovalLevels();
  }, []);

  useEffect(() => {
    if (userInputValue && userInputValue.trim().length > 3) {
      let searchText = userInputValue.trim().toLowerCase();
      let filtUsers = userList.filter(u => u.emailAddress.toLowerCase().indexOf(searchText) > -1);
      setFilteredUserList(filtUsers);
    } else {
      setFilteredUserList([]);
    }


  }, [userInputValue]);

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const getCompanies = () => {
    VendorMasterData.getCompanyCodes(
      function (companies: Array<Company>) {
        setCompanyList(companies);
      },
      function (error: Error) {
        setCompanyList([]);
      }
    );
  };

  const getApprovalLevels = () => {
    MasterMetaDataService.getApprovalLevels(
      function (approvalLevels: Array<ApprovalLevel>) {
        setApprovalPointList(approvalLevels);
      },
      function (error: Error) {
        setCompanyList([]);
      }
    );
  };


  const getUsers = () => {
    return MasterDataService.getUsers(
      function (users: User[]) {
        setUserList(users);
      },
      function (error: Error) {
        setUserList([]);
      }
    );
  };

  const filterOptionsCompanies = (options: Company[], state: any) => {
    return createFilterOptions({ stringify: (option: Company) => option.code })(options, state);
  };

  const handleChangeAutoCompete = (e: any, input: string, newValue: any) => {
    if (input === "companyCodes") {
      let companyCodes = newValue ? newValue.map((u: Company) => u.code) : [];
      setFilterParams({ ...filterParams!, [input]: companyCodes });
    } else if (input === "userIds") {
      let userIds = newValue ? newValue.map((u: User) => u.id) : [];
      setFilterParams({ ...filterParams!, [input]: userIds });
    } else if (input === "requestStatusIds") {
      let statusIds = newValue ? newValue.map((u: RequestStatusModel) => u.id) : [];
      setFilterParams({ ...filterParams!, [input]: statusIds });
    } else if (input === "approvalPointIds") {
      let approvalPointIds = newValue ? newValue.map((u: ApprovalLevel) => u.id) : [];
      setFilterParams({ ...filterParams!, [input]: approvalPointIds });
    }
    else if (input === "vendorTypes") {
      let vendorTypes = newValue ? newValue.map((u: VendorType) => u.code) : [];
      setFilterParams({ ...filterParams!, [input]: vendorTypes });
    }
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  const handleChange = (input: string) => (e: any) => {
    let val: any = e.target.value;
    if (e.target.type === "checkbox") {
      setFilterParams({ ...filterParams!, [input]: e.target.checked });
    }
    // else if(input === "sbuCodes" || input === "userRoles" ){
    //   setFilterParams({...filterParams!, [input]: e.target.value as string[]});
    // }    
    else {
      setFilterParams({ ...filterParams!, [input]: val });

      if (input == "reportType") {
        setVendorInputValue("");
        setSelectedVendorTypes([]);
        setFilterParams(prev => ({
          ...prev,
          vendorTypes: []
        }));
      }

    }
  };

  const handleFilter = (e: any) => {
    if (filterParams.reportType !== 0) {
      if (filterParams.reportType == 1 || filterParams.reportType == 2 || filterParams.reportType == 3 || filterParams.reportType == 4) {
        if (filterParams.fromDate !== "" && filterParams.toDate !== "") {
          prepareForRequest();
          ReportService.downlodReport(
            filterParams,
            function (success: any) {
              compeleteRequest(true);
            },
            function (error: any) {
              compeleteRequest(false, translation.report_get_nodata);
            }
          );
        } else {
          dispatch(
            AllActions.infoActions.openInforWarn(
              translation.report_get_validation,
              InforDisplyaDuration.common
            )
          );
        }
      }
      else if (filterParams.reportType == 5) {
       // if (filterParams.vendorTypes.length > 0) {
          prepareForRequest();
          ReportService.downlodReport(
            filterParams,
            function (success: any) {
              compeleteRequest(true);
            },
            function (error: any) {
              compeleteRequest(false, translation.report_get_nodata);
            }
          );
        /* }
        else {
          dispatch(
            AllActions.infoActions.openInforWarn(
              translation.report_get_validation_inactivedate_vendortype,
              InforDisplyaDuration.common
            )
          );
        } */
      }
      else if (filterParams.reportType == 6 || filterParams.reportType == 7 || filterParams.reportType == 8) {
        if (filterParams.fromDate !== "" && filterParams.toDate !== "") {
          prepareForRequest();
          ReportService.downlodReport(
            filterParams,
            function (success: any) {
              compeleteRequest(true);
            },
            function (error: any) {
              compeleteRequest(false, translation.report_get_nodata);
            }
          );
        }
        else {
          dispatch(
            AllActions.infoActions.openInforWarn(
              translation.report_get_validation_onboardedvendor_date_type,
              InforDisplyaDuration.common
            )
          );
        }
      }
    }
    else {
      dispatch(
        AllActions.infoActions.openInforWarn(
          translation.report_get_validation_reporttype,
          InforDisplyaDuration.common
        ));
    }
  };

  const showCompany = () => {
    return filterParams.reportType == 3 || filterParams.reportType == 4;
  };

  const showUser = () => {
    return filterParams.reportType == 3 || filterParams.reportType == 4;
  };

  const showRequestStatus = () => {
    return filterParams.reportType == 3;
  };

  const showApprovalPoint = () => {
    return filterParams.reportType == 3 || filterParams.reportType == 4;
  };

  const showVendorType = () => {
    return filterParams.reportType == 5;
  };
  const showAllVendorType = () => {
    return filterParams.reportType == 6 || filterParams.reportType == 7 || filterParams.reportType == 8;
  };


  return (
    <div>
      {/* Filter area START */}
      <div className={classes.contentOuterBG}>
        <Grid container spacing={1} item xs={12} sm={12} md={12} lg={12} className={classes.createHeader}>
          <span className={classes.createHeaderTxt}>Report</span>
        </Grid>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.filterheader} >
          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            <div className={classes.filterWrapper}>
              <div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_type}
                </label>
                <div className={classes.inputWrapper}>
                  <Select
                    variant="outlined"
                    value={filterParams.reportType || ""}
                    onChange={handleChange("reportType")}
                  >
                    {reportTypeList.map((obj, index) => (
                      <MenuItem key={obj.code} value={obj.code}>
                        {obj.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            {!showVendorType() && (<div className={classes.filterWrapper}>
              <div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_startdate}
                </label>
                <div className={classes.inputWrapper}>
                  <TextField
                    variant="outlined"
                    type="date"
                    onChange={handleChange("fromDate")}
                  ></TextField>
                </div>
              </div>
              <div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_enddate}
                </label>
                <div className={classes.inputWrapper}>
                  <TextField
                    variant="outlined"
                    type="date"
                    onChange={handleChange("toDate")}
                  ></TextField>
                </div>
              </div>
            </div>)}
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            <div className={classes.filterWrapper}>
              {showCompany() && (<div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_company}
                </label>
                <div className={classes.inputWrapper}>
                  <Autocomplete
                    multiple
                    options={companyList.map(
                      (obj: Company, index: number) => obj
                    )}
                    getOptionLabel={(option) => option.code}
                    filterOptions={filterOptionsCompanies}
                    onChange={(e, newValue) => {
                      e.preventDefault();
                      handleChangeAutoCompete(e, "companyCodes", newValue);
                    }}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        {option.name}
                      </React.Fragment>)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </div>
              </div>)}
              {showUser() && (<div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_user}
                </label>
                <div className={classes.inputWrapper}>
                  <Autocomplete
                    multiple
                    options={filteredUserList.map(
                      (obj: User, index: number) => obj
                    )}
                    getOptionLabel={(option) => option.userName}
                    filterOptions={(x) => x}
                    onChange={(e, newValue) => {
                      e.preventDefault();
                      handleChangeAutoCompete(e, "userIds", newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setUserInputValue(newInputValue);
                    }}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        {option.emailAddress}
                      </React.Fragment>)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </div>
              </div>)}
            </div>
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            <div className={classes.filterWrapper}>
              {showRequestStatus() && (<div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_request_status}
                </label>
                <div className={classes.inputWrapper}>
                  <Autocomplete
                    multiple
                    options={requestStatus.map(
                      (obj: RequestStatusModel, index: number) => obj
                    )}
                    getOptionLabel={(option) => option.name}
                    //filterOptions={filterOptionsCompanies}
                    onChange={(e, newValue) => {
                      e.preventDefault();
                      handleChangeAutoCompete(e, "requestStatusIds", newValue);
                    }}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        {option.name}
                      </React.Fragment>)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </div>
              </div>)}
              {showApprovalPoint() && (<div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_approval_points}
                </label>
                <div className={classes.inputWrapper}>
                  <Autocomplete
                    multiple
                    options={approvalPointList.map(
                      (obj: ApprovalLevel, index: number) => obj
                    )}
                    getOptionLabel={(option) => option.name}
                    //filterOptions={filterOptionsCompanies}
                    onChange={(e, newValue) => {
                      e.preventDefault();
                      handleChangeAutoCompete(e, "approvalPointIds", newValue);
                    }}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        {option.name}
                      </React.Fragment>)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </div>
              </div>)}
            </div>
          </Grid>

          {/* ---------------CR start------------------------ */}
          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            <div className={classes.filterWrapper}>
              {showVendorType() && (
                <div className={classes.dataBlock}>
                  <label className={classes.filterLbl}>
                    {translation.report_filter_vendorType}
                  </label>
                  <div className={classes.inputWrapper}>
                    <Autocomplete
                      multiple
                      options={vendorTypes.map(
                        (obj: VendorType, index: number) => obj
                      )}
                      getOptionLabel={(option) => option.name}
                      //filterOptions={filterOptionsCompanies}
                      onChange={(e, newValue) => {
                        e.preventDefault();
                        handleChangeAutoCompete(e, "vendorTypes", newValue);
                      }}
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          {option.name}
                        </React.Fragment>)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          variant="outlined"
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
              {/* {showVendorType() && (<div className={classes.dataBlock}>
                <label className={classes.filterLbl}>
                  {translation.report_filter_inactivefromDate}
                </label>
                <div className={classes.inputWrapper}>
                  <TextField
                    variant="outlined"
                    type="date"
                    onChange={handleChange("inActiveFromDate")}
                  ></TextField>
                </div>
              </div>)} */}
            </div>
          </Grid>
          {/* ----------------------------------- */}

          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            <div className={classes.filterWrapper}>
              {showAllVendorType() && (
                <div className={classes.dataBlock}>
                  <label className={classes.filterLbl}>
                    {translation.report_filter_vendorType}
                  </label>
                  <div className={classes.inputWrapper}>
                    <Autocomplete
                      multiple
                      options={allendorTypes.map(
                        (obj: VendorType, index: number) => obj
                      )}
                      value={selectedVendorTypes}
                      inputValue={vendorInputValue}
                      getOptionLabel={(option) => option.name}
                      //filterOptions={filterOptionsCompanies}
                      onChange={(e, newValue) => {
                        e.preventDefault();
                        setSelectedVendorTypes(newValue);
                        handleChangeAutoCompete(e, "vendorTypes", newValue);
                      }}

                      onInputChange={(e, newInputValue) => {
                        setVendorInputValue(newInputValue);
                      }}

                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          {option.name}
                        </React.Fragment>)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          variant="outlined"
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
          </Grid>


          <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>
            <div className={classes.filterWrapper}>
              <div className={classes.searchBtnWrapper}>
                <Button onClick={handleFilter} style={{ float: "left" }}>
                  <GetAppIcon></GetAppIcon>
                  {translation.report_filternm_btntxt}
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
